import store from '@/Store'

export const slugGenerator = (text) => text.normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(' ', '_')
  .replace(/[\W]/g, '')
  .toLowerCase()

export const encodeEmbedData = (string) => {
  let charCode = ''
  for (let letra of string) {
    charCode += (letra.charCodeAt(0) + 2).toString() + '.'
  }
  return btoa(charCode)
}

export const decodeEmbedData = (encodedString) => {
  // Convert Base64 to String and get charcode of chars
  const charCodeArr = atob(encodedString).split('.')
  let decodedData = ''
  charCodeArr.map((char) => {
    if (char !== '') {
      // convert charcode to String
      const character = String.fromCharCode((char - 2))
      decodedData += character
    }
  })
  return decodedData
}

export const permissoesTratadas = () => {
  let user = store.getters['Beneficiario/user'] || []
  let funcionalidadesFixas = funcionalidadesPadroes()
  let newPermissions = Array.isArray(user.permissoes) ? user.permissoes.filter((p) => !funcionalidadesFixas.includes(p.funcionalidade)) : []
  return newPermissions
}

export const funcionalidadesPadroes = () => {
  return ['1', '47777', '47888', '47999']
}
export const idFuncionalidadesOcultas = () => {
  let permissoes = permissoesTratadas()
  return permissoes.filter((perm) => perm.ocultar === true).map((perm) => perm.funcionalidade)
}

export const idFuncionalidadesSemAcesso = () => {
  let permissoes = permissoesTratadas()
  return permissoes.filter((perm) => perm.acesso === false).map((perm) => perm.funcionalidade)
}

export const isNotAccessGranted = (idFuncionalidade) => {
  let funcionalidadesSemAcesso = idFuncionalidadesSemAcesso()
  return funcionalidadesSemAcesso.includes(idFuncionalidade)
}
export const funcionalidadesArrayPermissao = () => {
  let funcionalidadesArrayPermissao = idFuncionalidadesSemAcesso()
  let funcionalidadesGruposSemAcesso = mapFuncionalidadesGruposSemAcesso()
  let funcionalidadesOcultas = idFuncionalidadesOcultas()
  funcionalidadesArrayPermissao = funcionalidadesArrayPermissao.concat(funcionalidadesGruposSemAcesso)
  funcionalidadesArrayPermissao = funcionalidadesArrayPermissao.concat(funcionalidadesOcultas)
  return funcionalidadesArrayPermissao
}

const mapFuncionalidadesGruposSemAcesso = () => {
  let dashboard = store.getters['SetupApp/dashBoard'] || []
  let grupos = dashboard.filter((p) => p.tipo === 'grupo')
  let permissoes = permissoesTratadas()
  let FuncionalidadesGrupos = []
  grupos.map((item) => {
    if (permissoes.find((perm) => perm.funcionalidade === item.id.toString())) {
      if (Object.prototype.hasOwnProperty.call(item, 'funcionalidades')) {
        item.funcionalidades.map((func) => FuncionalidadesGrupos.push(func.id))
      }
    }
  })
  return FuncionalidadesGrupos
}

export const allFuncionalidades = () => {
  let dashboard = store.getters['SetupApp/dashBoard'] || []
  let funcionalidades = dashboard.filter((p) => p.tipo === 'funcionalidade')
  let grupos = dashboard.filter((p) => p.tipo === 'grupo')
  let funcionalidadesGrupos = []
  grupos.map((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'funcionalidades')) {
      item.funcionalidades.map((func) => funcionalidadesGrupos.push(func))
    }
  })
  funcionalidades = funcionalidades.concat(funcionalidadesGrupos)
  funcionalidades = funcionalidades.concat(grupos)
  return funcionalidades
}

export const urlVerify = (url) => {
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://')
  } else if (!url.startsWith('https://')) {
    return 'https://' + url
  }
  return url
}

const inboxCountKeyRegex = /(unread|nao_?lida|naolida|inbox.*(count|total|qtd|quant)|count.*inbox|total.*inbox|qtd.*inbox|quant.*inbox|mensag.*(nao_?lida|unread|count|total|qtd|quant))/

const parseInboxCountValue = (value) => {
  const numericValue = Number(value)
  if (Number.isNaN(numericValue) || numericValue < 0) {
    return null
  }

  return numericValue
}

const normalizeKey = (key) => {
  if (typeof key !== 'string') {
    return ''
  }

  return key
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export const extractInboxBadgeCount = (source) => {
  const directValue = parseInboxCountValue(source)
  if (directValue !== null) {
    return directValue
  }

  if (!source || typeof source !== 'object') {
    return null
  }

  const visited = new WeakSet()
  const queue = [{ item: source, depth: 0 }]
  const maxDepth = 6

  while (queue.length > 0) {
    const { item, depth } = queue.shift()

    if (!item || typeof item !== 'object') {
      continue
    }

    if (visited.has(item)) {
      continue
    }

    visited.add(item)

    const entries = Array.isArray(item) ? item.entries() : Object.entries(item)
    for (const [rawKey, rawValue] of entries) {
      const key = normalizeKey(String(rawKey))
      const candidateValue = parseInboxCountValue(rawValue)

      if (candidateValue !== null && inboxCountKeyRegex.test(key)) {
        return candidateValue
      }

      if (depth < maxDepth && rawValue && typeof rawValue === 'object') {
        queue.push({ item: rawValue, depth: depth + 1 })
      }
    }
  }

  return null
}
